import { PermissionEnum } from '@Application/Security/Roles';
import { openContactSidebar } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/BeneficiaryContacts/Signals/contactSidebarSignal';
import WithPermission from '@UI/Providers/PermissionProvider/WithPermission';
import useIsBeneficiaryEditable from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/BeneficiaryContacts/Hooks/useIsBeneficiaryEditable';
import { Plus } from 'lucide-react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

/**
 * The "Ajouter un contact" action, gated behind `SUBJECT_WRITE` and hidden on an archived (or not
 * yet loaded) dossier. Rendered twice by this screen — once in `PageHeader.actions`, once in the empty
 * state's `action` — so it lives here rather than being duplicated inline at each call site.
 */
type Props = {
	readonly beneficiaryId: number | null;
};

const CreateContactButton: React.FC<Props> = ({ beneficiaryId }) => {
	const isEditable = useIsBeneficiaryEditable(beneficiaryId);

	const handleCreateClick = React.useCallback(() => {
		openContactSidebar(null);
	}, []);

	if (!isEditable) {
		return null;
	}

	return (
		<WithPermission permission={PermissionEnum.SUBJECT_WRITE}>
			<Button
				type="button"
				label="Ajouter un contact"
				icon={<Plus size={16} />}
				onClick={handleCreateClick}
			/>
		</WithPermission>
	);
};

export default CreateContactButton;
